import React from 'react';

function Text({ children }) {
  return <p className="text-sm text-dark-gray">{children}</p>;
}

export default Text;
